import {
  EBARIMT_LOADING,
  CREATE_EBARIMT,
  CREATE_EBARIMT_ERROR,
  DELETE_EBARIMT,
  SEND_EBARIMT,
} from "../actions/types";

const initialState = {
  receipt: null,
  loading: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case EBARIMT_LOADING:
      return { ...state, loading: true };
    case CREATE_EBARIMT:
      return { ...state, loading: false, receipt: payload };
    case CREATE_EBARIMT_ERROR:
      return { ...state, loading: false };
    case DELETE_EBARIMT:
      return { ...state, receipt: null };
    case SEND_EBARIMT:
      return { ...state };
    default:
      return state;
  }
}
